import Swiper from 'swiper';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Autoplay, Pagination, Navigation]);

// import { gsap } from "gsap";

const featureProdSlider = function (barba) {

	const speed = 2000
	const swiper = new Swiper('.feat-prod-swiper', {
		loop: false,
		loopPreventsSlide: false,
		slidesPerView: 4,
		// loopedSlides: 2,
		// effect: 'fade',
		cssMode: false,
		// allowTouchMove: false,
		// pagination: {
		// 	el: ".swiper-custom-pagination",
		// 	type: "fraction"
		// },
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
		speed: (speed / 2),
		// autoplay: {
		// 	delay: (speed * 2),
		// 	disableOnInteraction: false
		// },
		// fadeEffect: {
		// 	crossFade: true
		// },
		runCallbacksOnInit: false,
	})
}

export default featureProdSlider